import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How often do you use this product category? ",
                choices: [
                    generateNewChoice("Several times a week"),
                    generateNewChoice("About once a week"),
                    generateNewChoice("Several times a month"),
                    generateNewChoice("About once a month"),
                    generateNewChoice("Less than once a month"),
                    generateNewChoice("Never"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "How well do current products on the market meet your needs? ",
                choices: [
                    generateNewChoice("Extremely well"),
                    generateNewChoice("Very well"),
                    generateNewChoice("Somewhat well"),
                    generateNewChoice("Not so well"),
                    generateNewChoice("Not at all well"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        headline:
            "We’ll now show you a new product idea and ask for your feedback.",
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your first reaction to the product?",
                choices: [
                    generateNewChoice("Very positive"),
                    generateNewChoice("Somewhat positive"),
                    generateNewChoice("Neutral"),
                    generateNewChoice("Somewhat negative"),
                    generateNewChoice("Very negative"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "How innovative is the product?",
                choices: [
                    generateNewChoice("Extremely innovative"),
                    generateNewChoice("Very innovative"),
                    generateNewChoice("Somewhat innovative"),
                    generateNewChoice("Not so innovative"),
                    generateNewChoice("Not at all innovative"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "If the service were available today, how likely would you be to buy the product?",
                choices: [
                    generateNewChoice("Extremely likely"),
                    generateNewChoice("Very likely"),
                    generateNewChoice("Somewhat likely"),
                    generateNewChoice("Not so likely"),
                    generateNewChoice("Not at all likely"),
                ],
            },
        ],
    },
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your gender?",
                choices: [
                    generateNewChoice("Female"),
                    generateNewChoice("Male"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "What is your age?",
                choices: [
                    generateNewChoice("Under 18"),
                    generateNewChoice("18-24"),
                    generateNewChoice("25-34"),
                    generateNewChoice("35-44"),
                    generateNewChoice("45-54"),
                    generateNewChoice("55-64"),
                    generateNewChoice("65+"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "Do you live in an urban suburban, or rural area?",
                choices: [
                    generateNewChoice("Urban"),
                    generateNewChoice("Suburban"),
                    generateNewChoice("Rural"),
                ],
            },
        ],
    },
];

export const marketSizingSurveyTemplate = generateSurveyTemplate({
    name: "Market Sizing Survey",
    pages,
});
